 <!--<printheaderview [hasimage]="1"></printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-11 text-align-center">
            <label class="font-familyhead">Case Record</label>
          </div>
        </div>


        <div class="col-print-12 bordertop">
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">CASE RECORD NO:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.FFormattedCode}}</label>
            </div>
          </div>

          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">MARRIAGE DATE:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.MarriageDate | date:'dd-MMM-yyyy'}}</label>
            </div>
          </div>
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REGISTRATION DATE:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.RegistrationDate | date:'dd-MMM-yyyy'}}</label>
            </div>
          </div>
          <!--<div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">PRIMARY CARE GIVEN BY:</label>
            </div>
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>-->
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REFFERED BY :</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.ReferredBy}}</label>
            </div>
          </div>
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REFERRAL DETAIL:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.RefDetails}}</label>
            </div>
          </div>
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REF.CLINIC NAME:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.RefClinic}}</label>
            </div>
          </div>
          <!--<div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REF.CLINIC NAME:</label>
            </div>
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>-->
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal">REF.CONTACT NO:</label>
            </div>
            <div class="col-print-8" *ngIf="PatientDetailsData">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.ReferralContact}}</label>
            </div>
          </div>
          <div class="row margin-left-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-8">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>

        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <!--<img class="user-image-circle-65px img200px" src="dummy.jpg">-->
                  <img class="user-image-circle-65px img200px" [src]='PatientDetailsData.FPatientImageFile' onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">NAME:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.FDisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">REG NO:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.FFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">DOB:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.FDateOfBirth | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">ADDRESS:</label>
                </div>
                <div class="col-print-8">
                  <div class="row margin-left-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.AddressLine1}}</label>
                  </div>
                  <div class="row margin-left-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.City}}</label>
                  </div>
                  <div class="row margin-left-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.State}}</label>
                  </div>
                  <div class="row margin-left-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.Country}} {{PatientDetailsData.Zip}}</label>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">PHONE NO:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.FTelephone1}}</label>
                </div>
              </div>
            </div>
            <div class="col-print-1 border-right-1px">

            </div>
            <div class="col-print-5">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <!--<img class="user-image-circle-65px img200px" src="dummy.jpg">-->
                  <img class="user-image-circle-65px img200px" [src]='PatientDetailsData.MPatientImageFile' onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal"></label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">NAME:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.MDisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">REG NO:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.MFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">DOB:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.MDateOfBirth | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">ADDRESS:</label>
                </div>
                <div class="col-print-8">
                  <div class="row margin-left-0px margin-right-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.AddressLine1}}</label>
                  </div>
                  <div class="row margin-left-0px margin-right-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.City}}</label>
                  </div>
                  <div class="row margin-left-0px margin-right-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.State}}</label>
                  </div>
                  <div class="row margin-left-0px margin-right-0px" *ngIf="PatientDetailsData">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.Country}} {{PatientDetailsData.Zip}}</label>
                  </div>
                </div>
              </div>
              <div class="row margin-left-10px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">PHONE NO:</label>
                </div>
                <div class="col-print-8" *ngIf="PatientDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientDetailsData.MTelephone1}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>

<!--<printcaserecfooterview></printcaserecfooterview>-->

<div class="">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
    <div class="col-print-6">
      <label class="margin-bottom-0px font-family"></label>
    </div>
  </div>
  <div class="card">

    <div class="card-header border-bottom-0px">

    </div>
    <div class="card-body padding-top-0px padding-bottom-0px">
      <div class="row" *ngIf="DoctorDetailsData">
        <div class="col-print-12 text-align-right">
          <label class="margin-bottom-0px font-familysubhead text-align-center">{{DoctorDetailsData.SignAuthority}}</label>
        </div>
      </div>
      <div class="row text-align-center" *ngIf="DoctorDetailsData">
        <div class="col-print-12 text-align-right">
          <label class="margin-bottom-0px font-family text-align-center">{{DoctorDetailsData.Line1}}</label>
        </div>
      </div>
      <div class="row text-align-center" *ngIf="DoctorDetailsData">
        <div class="col-print-12 text-align-right">
          <label class="margin-bottom-0px font-family text-align-center">{{DoctorDetailsData.Line2}}</label>
        </div>
      </div>
    </div>


    <!--<div class="row">
      <div class="col-md-4">
        <label class="margin-bottom-0px font-family">Print Taken On:</label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left">{{Date | date:'dd-MMM-yyyy'}}</label>
      </div>
    </div>-->
  </div>

</div>
